/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import { DEFAULT_CURRENCY_CODE, enableProdMode } from '@angular/core';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import { SHELL_HOME_CONFIG_RI, ShellHomeConfigRi } from '@r1-development/rps-shared-ui';
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import CodeMirror from 'codemirror';
import 'codemirror/mode/sql/sql';

// Expose CodeMirror as a global so @ctrl/ngx-codemirror can find it
// (the library checks `typeof CodeMirror !== 'undefined'` before calling fromTextArea)
(window as any).CodeMirror = CodeMirror;

ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);
provideGlobalGridOptions({ theme: 'legacy' });

LicenseManager.setLicenseKey(environment.agGridLicenseKey);

if (environment.production) {
  enableProdMode();
  window.console.log = () => {
    /* Remove Console Logging in production builds */
  };
}

platformBrowser([
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: {
      appearance: 'outline',
      subscriptSizing: 'dynamic',
    },
  },
  {
    provide: MAT_SELECT_CONFIG,
    useValue: {
      panelWidth: '',
      hideSingleSelectionIndicator: true,
    },
  },
  {
    provide: SHELL_HOME_CONFIG_RI,
    useValue: {
      adminUrl: environment.ui.adminURL,
      isLocal: window.location.origin.includes('localhost'),
      logoutWhenIdle: true,
      sidebarMenuGroup: environment.applicationGroupName,
      riUserManagementApiUrl: environment.api.riUserManagementUrl,
      usePendo: environment.isPendo,
    } as ShellHomeConfigRi,
  },
])
  .bootstrapModule(AppModule, {
    providers: [{ provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' }],
  })
  .catch((err) => console.error(err));
